export const reportNameMapper = {
  report1: "รายงานการเบิกค่ารักษาพยาบาล (รายพนักงาน)",
  report2: "รายงานการเบิกค่ารักษาพยาบาลตามฝ่าย/สังกัด",
  report3: "รายงานเงินช่วยเหลือบุตร (รายพนักงาน)",
  report4: "รายงานเงินช่วยเหลือบุตรที่ยังไม่เกิน 18 ปีบริบูรณ์ (รายพนักงาน)",
  report5: "รายงานประวัติการเบิกเงินช่วยเหลือบุตร",
  report6: "รายงานการเบิกค่าช่วยเหลือการศึกษาบุตร (รายพนักงาน)",
  report7: "รายงานการเบิกค่าช่วยเหลือจัดการงานศพ (3 เท่า)",
  report8: "รายงานการเบิกค่าเจ้าภาพงานศพ",
  report9: "รายงานการเบิกค่าอุปกรณ์เคารพศพ",
  report10: "สรุปการเบิกค่ารักษาพยาบาลตามฝ่าย/สังกัด",
  report11: "สรุปการเบิกค่าเล่าเรียนบุตรตามฝ่าย/สังกัด",
  report12: "สรุปการเบิกเงินช่วยเหลือบุตรตามฝ่าย/สังกัด",
  report13: "รายงานเงินช่วยเหลือบุตร (เพิ่มขึ้น) ตามฝ่าย/สังกัด",
  report14: "รายงานเงินช่วยเหลือบุตร (ลดลง) ตามฝ่าย/สังกัด",
  report15: "สรุปรายการเบิกทั้งหมด รายครั้ง",
  report16: "รายงาน migrations",

  report17: "รายงานสรุปวงเงินคงเหลือ (รายพนักงาน)",
  report18: "สรุปรายการปรับปรุงเงินเดือน",

  // testByDev: "Test By Dev",
};
